import {HTMLAttributes} from 'react';
import {Button, ButtonGroup, ButtonProps} from '@/components/Button';
import {Modal, ModalProps} from '@/components/Modal';
import {Typography} from '@/components/Typography';
import {PaddingBox} from '@/styled-components';
import {palette} from '@/styles';
import styled from 'styled-components';

interface IProps extends ModalProps {
  confirmLabel?: string;
  cancelLabel?: string;
  confirmOptions?: ButtonProps & HTMLAttributes<HTMLButtonElement>;
  cancelOptions?: ButtonProps & HTMLAttributes<HTMLButtonElement>;
  onConfirm?(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
  onCancel?(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
}

export const Dialog = ({
  confirmLabel,
  cancelLabel,
  confirmOptions,
  cancelOptions,
  children,
  onConfirm,
  onCancel,
  ...props
}: IProps) => {
  return (
    <Modal width={368} {...props}>
      <PaddingBox spacing={16}>
        <Typography as="div" variant="medium14" color={palette.gray600}>
          {children}
        </Typography>
      </PaddingBox>
      <PaddingBox top={0} left={24} right={24} bottom={24}>
        <ButtonGroup>
          <CancelButton
            variant="outline"
            size="medium"
            color="black"
            {...cancelOptions}
            onClick={onCancel}
          >
            {cancelLabel || '취소'}
          </CancelButton>
          <ConfirmButton
            variant="fill"
            size="medium"
            color="primary"
            {...confirmOptions}
            onClick={onConfirm}
          >
            {confirmLabel || '확인'}
          </ConfirmButton>
        </ButtonGroup>
      </PaddingBox>
    </Modal>
  );
};

const CancelButton = styled(Button)`
  width: 96px;
  flex-shrink: 0;
`;

const ConfirmButton = styled(Button)`
  flex-grow: 1;
`;
